import React from "react";

import { humaniseKey } from "./auditFormatters";
import { formatAuditDisplayValue } from "./auditValueDisplay";

export default function AuditSnapshotSection({ snapshot }) {
  const entries = Object.entries(snapshot ?? {});
  if (entries.length === 0) return null;

  return (
    <dl className="mt-3 grid grid-cols-1 gap-x-6 gap-y-1.5 sm:grid-cols-2">
      {entries.map(([key, val]) => (
        <div key={key} className="flex gap-2 text-sm">
          <dt className="font-medium text-[#0F172A]">{humaniseKey(key)}:</dt>
          <dd className="text-[#64748B]">{formatAuditDisplayValue(val)}</dd>
        </div>
      ))}
    </dl>
  );
}
